/** P014 debug console log: ring buffer of commands sent through the bridge. */
export interface DebugEntry { at: number; type: string; payload: string }
const LIMIT = 40;
const entries: DebugEntry[] = [];
const listeners = new Set<() => void>();

export function logCommand(type: string, payload: unknown): void {
  let text: string;
  try { text = JSON.stringify(payload); } catch { text = '[unserializable]'; }
  entries.unshift({ at: Date.now(), type, payload: text });
  if (entries.length > LIMIT) { entries.length = LIMIT; }
  listeners.forEach((fn) => { fn(); });
}
export function getEntries(): readonly DebugEntry[] { return entries; }
export function onDebugChange(fn: () => void): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}
